"use client";
import { linkType } from "@/apiUtils/constants";
import {
  PortableTextProps,
  PortableTextReactComponents,
  PortableText as SanityPortableText,
} from "next-sanity";
import root from "react-shadow";
import { CLink } from "./common/customLink/CustomLink";
import React from "react";
import { useParams } from "next/navigation";
import { getCurrencyCode, PTConverter } from "@/apiUtils/commonUtils";
import CurrencyIcon from "@/common/core/icons/CurrencyIcon";

const PortableText = ({ value }: PortableTextProps) => {
  const params = useParams();
  const locale = params?.locale as string;
  const currencyCode = getCurrencyCode(locale);

  const components: Partial<PortableTextReactComponents> = {
    types: {
      currencyIcon: ({ value }: any) => <CurrencyIcon currency={value?.currency || currencyCode} />,
    },
    marks: {
      link: ({ children, value }) => {
        return (
          <CLink
            className="underline"
            href={value.url}
            target={value?.type === linkType.EXTERNAL ? "_blank" : ""}
          >
            {children}
          </CLink>
        );
      },
    },
    block: {
      normal: ({ children }) => {
        if (children && Array.isArray(children) && children[0] === "") {
          return <br />;
        }

        return <p className="my-4 text-[14px]">{children}</p>;
      },
      h1: ({ children }) => {
        return <h1 className="text-[32px] font-bold">{children}</h1>;
      },
      h2: ({ children }) => {
        return <h2 className="text-[22px] font-semibold">{children}</h2>;
      },
      h3: ({ children }) => {
        return <h3 className="text-[18px] font-semibold">{children}</h3>;
      },
      h4: ({ children }) => {
        return <h4 className="text-[16px] font-medium">{children}</h4>;
      },
      h5: ({ children }) => {
        return <h5 className="text-[14px] font-medium">{children}</h5>;
      },
      h6: ({ children }) => {
        return <h6 className="text-[12px] font-normal">{children}</h6>;
      },
    },
  };

  return (
    <root.span>
      <style>
        {`
            p {
                margin: 0;
                padding: 0;
                font-size: 14px;
              }
            a {
                color: #666666;
                text-decoration: underline;
                cursor: pointer;
              }
            .dirham-symbol {
              font-family: var(--font-currency-aed, sans-serif);
              font-size: 0.75em !important;
            }
            .riyal-symbol {
              font-family: var(--font-currency-sar, sans-serif);
              font-size: 0.75em !important;
            }
          `}
      </style>
      <SanityPortableText value={PTConverter(value)} components={components} />
    </root.span>
  );
};

export default PortableText;
